import {
  IconButton,
  Text,
  IconCommentLine,
  IconCommentsOffLine,
  Flex,
  View,
  IamProtected,
} from '@smarterservices/smarter-ui';
import ReviewerTools from './ReviewerTools';
import ReviewerComments from './ReviewerComments';
import AnnotationDetails from './AnnotationDetails';
import DeleteAnnotationButton from './ReviewerTools/DeleteAnnotationButton';
import ApproveAnnotationButton from './ReviewerTools/ApproveAnnotationButton';
import ViewAnnotationButton from './ReviewerTools/ViewAnnotationButton';
import { useState, useRef, useCallback, memo, useEffect } from 'react';
import CONSTANTS from '../../../config/constants';
import { getStore } from '../../../stores/StoreContext';
import AdjustAnnotationButton from './ReviewerTools/AdjustAnnotationButton';
const LineDetail = memo(({ annotation, hideMenu, reviewerTools, details }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showReviewerComments, setShowReviewerComments] = useState(false);
  const [hasReviewerComments, setHasReviewerComments] = useState(false);
  const [deleteConfirmMode, setDeleteConfirmMode] = useState(false);
  const menuTriggerRef = useRef(null);
  const reviewerCommentsRef = useRef(null);
  const ExamSessionStore = getStore('examSessionStore');
  const PlayerStore = getStore('playerStore');
  const AppStore = getStore('appStore');

  // Memoize handlers to prevent recreation on each render
  const handleDelete = useCallback(() => {
    if (annotation) {
      ExamSessionStore.deleteAnnotation(annotation.sid);
      setShowMenu(false);
    }
  }, [annotation, ExamSessionStore]);

  const handleJumpTo = useCallback(() => {
    if (annotation) {
      PlayerStore.jumpTo(
        annotation.start > CONSTANTS.ANNOTATIONS.SECONDS_LEADING_TO_ANNOTATION
          ? annotation.start -
          CONSTANTS.ANNOTATIONS.SECONDS_LEADING_TO_ANNOTATION
          : 0
      );
      setShowMenu(false);
    }
  }, [annotation]);

  const handleView = useCallback(() => {
    if (annotation) {
      // Use a safer approach to avoid ref issues
      // First close the menu to prevent any potential ref conflicts
      setShowMenu(false);

      // Use a small timeout to ensure the menu is fully closed before setting the annotation
      setTimeout(() => {
        ExamSessionStore.setManagingAnnotation(annotation);
      }, 50);
    }
  }, [annotation, ExamSessionStore]);

  useEffect(() => {
    if (annotation) {
      setHasReviewerComments(annotation?.reviewerComment && annotation?.reviewerComment !== '');
    }
  }, [annotation]);

  // If no annotation is available, don't render anything
  if (!annotation) {
    return null;
  }

  if (!details && !reviewerTools) {
    return null;
  }


  return (
    <View
      as="div"
      padding="x-small none"
    >
      <Flex>
        <Flex.Item shouldGrow>
          {details && (
            <View as="div" className="annotation-details" >
              <AnnotationDetails
                annotation={annotation}
              />
            </View>
          )}
          {reviewerTools && (
            <View as="div"
              className="annotation-tools"
              background="primary-inverse"
              borderWidth="small"
              borderColor="primary"
              borderRadius="medium"
              padding="x-small" margin="none xx-small none none" >
              <Flex justifyItems="space-between">
                <Flex.Item>

                  <ApproveAnnotationButton
                    annotation={annotation}
                  />
                  <DeleteAnnotationButton
                    annotation={annotation}
                  />
                  <AdjustAnnotationButton
                    annotation={annotation}
                  />

                  <IamProtected
                    action="sp:ModifyExamAnnotation"
                    resource={AppStore.getIamResourceString(`session/${ExamSessionStore.sessionSid}`)}
                  >
                    {(!hasReviewerComments && !showReviewerComments) && (
                      <IconButton
                        size="small"
                        margin="none x-small none none"
                        screenReaderLabel="Edit Annotation"
                        onClick={() => {
                          setShowReviewerComments(true);
                          setTimeout(() => {
                            if (reviewerCommentsRef.current) {
                              reviewerCommentsRef.current.startEditing();
                            }
                          }, 100);
                        }}
                      >
                        <IconCommentLine />
                      </IconButton>
                    )}

                    {(!hasReviewerComments && showReviewerComments) && (
                      <IconButton
                        size="small"
                        margin="none x-small none none"
                        screenReaderLabel="Edit Annotation"
                        onClick={() => setShowReviewerComments(false)}
                      >
                        <IconCommentsOffLine />
                      </IconButton>
                    )}
                  </IamProtected>

                  <ViewAnnotationButton
                    annotation={annotation}
                  />

                </Flex.Item>
                <Flex.Item>
                  <Text fontStyle="italic" size="contentSmall">
                    Created By:{' '}
                    {annotation.createdBy === 'VirtualAgent'
                      ? 'AI Proctor'
                      : annotation.createdBy}
                  </Text>
                </Flex.Item>
              </Flex>
              {((annotation?.reviewerComment && annotation?.reviewerComment !== '') || showReviewerComments) && (
                <ReviewerComments
                  ref={reviewerCommentsRef}
                  annotation={annotation}
                />
              )}
            </View>
          )}
        </Flex.Item>
      </Flex>
    </View>
  );
});

export default LineDetail;
